import {
  Layout,
  Typography,
  Card,
  Space,
  Divider,
  Row,
  Col,
  Image,
} from 'antd';
import {
  FileTextOutlined,
  MailOutlined,
  HomeOutlined,
} from '@ant-design/icons';

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

export const TermsConditions = () => {
  return (
    <Layout style={{ backgroundColor: '#f5f5f5',
      minHeight: '100vh' }}>
      <Content style={{ padding: '24px',
        margin: '0 auto',
        overflow: 'auto' }}>
        <Card
          style={{
            marginBottom: '24px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          }}
        >
          <Row justify="space-between" align="middle">
            <Col>
              <Space size="large">
                <Space>
                  <FileTextOutlined style={{ fontSize: '24px',
                    color: '#c32dee' }} />
                  <Title level={2} style={{ margin: 0,
                    color: '#262626' }}>
                    Términos y Condiciones
                  </Title>
                </Space>
              </Space>
            </Col>
          </Row>
        </Card>

        {/* Main Content */}
        <Card
          style={{
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          }}
        >
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            {/* Brand Header */}
            <div style={{ textAlign: 'center',
              marginBottom: '32px' }}>
              <Image src="/logo-pollo-loco.png" style={{ width: '15%' }} /> <br />
              <Text type="secondary" style={{ fontSize: '16px' }}>
                Términos y Condiciones de Uso
              </Text>
            </div>

            <Divider />

            {/* Section 1: Introducción */}
            <div>
              <Title level={3} style={{ color: '#c32dee',
                marginBottom: '16px' }}>
                1. Introducción
              </Title>
              <Paragraph style={{ fontSize: '16px',
                lineHeight: '1.6',
                textAlign: 'justify' }}>
                Bienvenido(a) a la aplicación móvil <Text strong>&quot;Pollo Loco&quot;</Text>. El acceso y uso de esta aplicación,
                así como la compra de nuestros productos y servicios, están sujetos a los presentes Términos y Condiciones.
                Al utilizar la app, usted acepta estos términos en su totalidad.
              </Paragraph>
            </div>

            <Divider />

            {/* Section 2: Uso de la Aplicación */}
            <div>
              <Title level={3} style={{ color: '#c32dee',
                marginBottom: '16px' }}>
                2. Uso de la Aplicación
              </Title>
              <Space direction="vertical" size="small" style={{ width: '100%' }}>
                <Paragraph style={{ fontSize: '16px',
                  lineHeight: '1.6',
                  textAlign: 'justify',
                  marginBottom: '8px' }}>
                  • La app <Text strong>&quot;Pollo Loco&quot;</Text> permite a los usuarios consultar el menú, realizar pedidos y efectuar pagos en línea.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px',
                  lineHeight: '1.6',
                  textAlign: 'justify' }}>
                  • El usuario se compromete a proporcionar información veraz y actualizada para poder procesar correctamente sus pedidos.
                </Paragraph>
              </Space>
            </div>

            <Divider />

            {/* Section 3: Precios y Pagos */}
            <div>
              <Title level={3} style={{ color: '#c32dee',
                marginBottom: '16px' }}>
                3. Precios y Pagos
              </Title>
              <Space direction="vertical" size="small" style={{ width: '100%' }}>
                <Paragraph style={{ fontSize: '16px',
                  lineHeight: '1.6',
                  textAlign: 'justify',
                  marginBottom: '8px' }}>
                  • Todos los precios están expresados en <Text strong>pesos mexicanos (MXN)</Text> e incluyen los impuestos aplicables,
                  salvo que se indique lo contrario.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px',
                  lineHeight: '1.6',
                  textAlign: 'justify',
                  marginBottom: '8px' }}>
                  • El pago de las órdenes se procesa a través de la pasarela de pagos <Text strong>Openpay</Text>,
                  que actúa como proveedor autorizado para la gestión segura de transacciones.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px',
                  lineHeight: '1.6',
                  textAlign: 'justify',
                  marginBottom: '8px' }}>
                  • Se aceptan pagos con <Text strong>Visa, MasterCard y American Express</Text>.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px',
                  lineHeight: '1.6',
                  textAlign: 'justify' }}>
                  • El usuario declara conocer y aceptar que el procesamiento del pago está sujeto a las políticas de
                  Openpay y de las entidades emisoras de las tarjetas utilizadas.
                </Paragraph>
              </Space>
            </div>

            <Divider />

            {/* Section 4: Confirmación y Entrega */}
            <div>
              <Title level={3} style={{ color: '#c32dee',
                marginBottom: '16px' }}>
                4. Confirmación y Entrega de Pedidos
              </Title>
              <Space direction="vertical" size="small" style={{ width: '100%' }}>
                <Paragraph style={{ fontSize: '16px',
                  lineHeight: '1.6',
                  textAlign: 'justify',
                  marginBottom: '8px' }}>
                  • Una vez confirmado el pago, el pedido será procesado y preparado para entrega o recolección según la modalidad seleccionada.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px',
                  lineHeight: '1.6',
                  textAlign: 'justify' }}>
                  • El tiempo de entrega puede variar según disponibilidad de productos, demanda y ubicación del usuario.
                </Paragraph>
              </Space>
            </div>

            <Divider />

            {/* Section 5: Cancelaciones y Reembolsos */}
            <div>
              <Title level={3} style={{ color: '#c32dee',
                marginBottom: '16px' }}>
                5. Cancelaciones y Reembolsos
              </Title>
              <Space direction="vertical" size="small" style={{ width: '100%' }}>
                <Paragraph style={{ fontSize: '16px',
                  lineHeight: '1.6',
                  textAlign: 'justify',
                  marginBottom: '8px' }}>
                  • Las cancelaciones deberán solicitarse antes de que el pedido haya sido preparado.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px',
                  lineHeight: '1.6',
                  textAlign: 'justify' }}>
                  • En caso de que proceda un reembolso, éste se realizará por el mismo método de pago utilizado,
                  siguiendo los tiempos establecidos por Openpay y las instituciones bancarias.
                </Paragraph>
              </Space>
            </div>

            <Divider />

            {/* Section 6: Responsabilidad */}
            <div>
              <Title level={3} style={{ color: '#c32dee',
                marginBottom: '16px' }}>
                6. Responsabilidad
              </Title>
              <Paragraph style={{ fontSize: '16px',
                lineHeight: '1.6',
                textAlign: 'justify' }}>
                <Text strong>&quot;Pollo Loco&quot;</Text> no será responsable por fallas o interrupciones en el servicio causadas por terceros,
                incluyendo, pero no limitado a, proveedores de internet, procesadores de pagos, y empresas de mensajería.
              </Paragraph>
            </div>

            <Divider />

            {/* Section 7: Modificaciones */}
            <div>
              <Title level={3} style={{ color: '#c32dee',
                marginBottom: '16px' }}>
                7. Modificaciones
              </Title>
              <Paragraph style={{ fontSize: '16px',
                lineHeight: '1.6',
                textAlign: 'justify' }}>
                Nos reservamos el derecho de modificar en cualquier momento estos Términos y Condiciones.
                Las versiones actualizadas estarán disponibles dentro de la aplicación.
              </Paragraph>
            </div>

            <Divider />

            {/* Section 8: Contacto */}
            <div>
              <Title level={3} style={{ color: '#c32dee',
                marginBottom: '16px' }}>
                8. Contacto
              </Title>
              <Paragraph style={{ fontSize: '16px',
                lineHeight: '1.6',
                marginBottom: '16px' }}>
                Para cualquier duda, aclaración o comentario, puede escribirnos a:
              </Paragraph>

              <Card
                style={{
                  backgroundColor: '#f9f9f9',
                  border: '1px solid #e8e8e8',
                  borderRadius: '8px',
                }}
              >
                <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                  <Space size="middle">
                    <MailOutlined style={{ color: '#c32dee',
                      fontSize: '18px' }} />
                    <div>
                      <Text strong>Correo Electrónico:</Text>
                      <br />
                      <Text copyable style={{ color: '#c32dee' }}>
                        polloloco@abdotech.mx
                      </Text>
                    </div>
                  </Space>

                  <Space size="middle" align="start">
                    <HomeOutlined style={{ color: '#c32dee',
                      fontSize: '18px',
                      marginTop: '4px' }} />
                    <div>
                      <Text strong>Domicilio:</Text>
                      <br />
                      <Text style={{ lineHeight: '1.6' }}>
                        Boulevard Miguel Ramos Arizpe Sur #18<br />
                        Col. Ramos Arizpe Centro<br />
                        C.P. 25900, Ramos Arizpe<br />
                        Coahuila de Zaragoza, México
                      </Text>
                    </div>
                  </Space>
                </Space>
              </Card>
            </div>

            {/* Footer */}
            <div style={{ textAlign: 'center',
              marginTop: '48px',
              paddingTop: '24px',
              borderTop: '1px solid #f0f0f0' }}>
              <Text type="secondary" style={{ fontSize: '14px' }}>
                © 2025 Pollo Loco. Todos los derechos reservados.
              </Text>
              <br />
              <Text type="secondary" style={{ fontSize: '12px' }}>
                Última actualización: Agosto 2025
              </Text>
            </div>
          </Space>
        </Card>
      </Content>
    </Layout>
  );
};
